import type { SWRConfiguration } from 'swr'
import useSWR from 'swr'

import { getPayoneerLink } from '../api/accountsApi'
import { PayoneerLink } from '../types'

export default function usePayoneerLink(options?: SWRConfiguration) {
  return useSWR<PayoneerLink, Error>('payoneer/link', getPayoneerLink, options)
}
